import type { DonutSegment } from './Donut'

/** Số đơn theo nhóm trạng thái — khớp `summary` của /reports/agency-network. */
export interface StatusCounts {
  deliveredOrders: number
  deliveringOrders: number
  returnedOrders: number
  pendingOrders?: number
  /** Không vẽ: đơn hủy không phải đơn bán (giao diện ghi chú riêng "không tính N đơn hủy") */
  cancelledOrders?: number
  otherOrders?: number
}

/**
 * Các cung của vòng tròn trạng thái. Thứ tự màu đã kiểm tra phân biệt được
 * với người mù màu (xanh lá · tím · hổ phách · xanh dương); "Khác" (chờ duyệt…)
 * là nhóm màu xám, luôn có nhãn + số bên cạnh. Đơn hủy KHÔNG vào vòng tròn.
 */
export function statusSegments(s: StatusCounts | undefined | null): DonutSegment[] {
  return [
    { key: 'delivered', label: 'Đã giao', value: s?.deliveredOrders ?? 0, color: '--c-delivered' },
    { key: 'shipping', label: 'Đang giao', value: s?.deliveringOrders ?? 0, color: '--c-shipping' },
    { key: 'returned', label: 'Hoàn', value: s?.returnedOrders ?? 0, color: '--c-returned' },
    { key: 'pending', label: 'Chờ lấy', value: s?.pendingOrders ?? 0, color: '--c-pending' },
    { key: 'other', label: 'Khác', value: s?.otherOrders ?? 0, color: '--c-other' },
  ]
}
